<template>
  <div>
    <!-- 马来西亚 Step2：questionnaire 90% 与新加坡相似，无 FUND 相关内容 -->
    <questionnaire
      :key="new Date().getTime()"
      country="Malaysia"
      :applymentId="detail.id"
      :applymentStatus="detail.applymentStatus"
      :questionnaire="detail.questionnaire"
      :businessType="detail.businessType"
      :fundInfoList="detail.fundInfoList || []"
      :businessGenre="detail.businessGenre"
      :registeredOfficeType="detail.registeredOfficeType"
      :registeredOfficeAddress="detail.registeredOfficeAddress"
      :registeredOfficeCity="detail.registeredOfficeCity"
      :registeredOfficeCountry="detail.registeredOfficeCountry"
      :registeredOfficePostalCode="detail.registeredOfficePostalCode"
      :registeredOfficeId="detail.registeredOfficeId"
      :nativeRegisteredAddress="nativeRegisteredAddress"
      :isNeedNomineeDirector="isNeedNomineeDirector"
      :hasNomineeDirector="detail.hasNomineeDirector"
    />
    <!-- 马来西亚 Step2 shareholders-detail（无 FUND_ADMIN_CUSTOMIZED） -->
    <shareholders-detail
      class="mt40"
      stepName="kycQuestionnaire"
      country="Malaysia"
      :applymentId="detail.id"
      :applymentStatus="detail.applymentStatus"
      :companyMemberList="detail.companyMemberList"
      :hasNomineeDirector="detail.hasNomineeDirector"
      :businessType="detail.businessType"
      :appointNomineeDirector="detail.questionnaire.appointNomineeDirector || { type: null, name: null }"
      :supplierList="detail.supplierList"
      :quotationList="detail.quotationList || []"
      :headline="`Information of the proposed company's officer(s)`"
      :isNeedNomineeDirector="isNeedNomineeDirector"
      v-if="detail.businessType === 'SERVICE_TRANSFER' || detail.businessType === 'COMPREHENSIVE_CUSTOMIZED'"
    />
  </div>
</template>

<script>
import Questionnaire from "../common/questionnaire";
import ShareholdersDetail from "../common/shareholdersDetail";
export default {
  components: {
    Questionnaire,
    ShareholdersDetail,
  },
  props: {
    detail: {
      type: Object,
      required: true,
    },
    nativeRegisteredAddress: {
      type: Array,
      default: () => [],
    },
    isNeedNomineeDirector: {
      type: Boolean,
    },
  },
};
</script>
